<template>
    <div>
        <confirm-dialog
            :is-open="premiumRequiredDialog"
            :width="600"
            border-style
            :buttons="false"
            @closed="() => this.premiumRequiredDialog = false">
            <template v-slot:title>
                <v-icon
                    class="mr-3"
                    color="accent2">
                    mdi-creation
                </v-icon>
                <span class="font-weight-bold">
                    Subscribe to Premium
                </span>
            </template>
            <template v-slot:default>
                <div class="text-center">
                    <img
                        class="mx-auto"
                        :src="asset(require('../../../images/graphics_placeholder.png'))"
                        alt="ICC Digital Codes Premium" />
                </div>
                <v-row>
                    <v-col>
                        <h3 class="font-weight-regular text-center my-4">
                            You need a Premium subscription to <span class="bold">{{graphicDetails.document_title}}</span> to view this graphic.
                        </h3>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                        class="text-center">
                        <v-btn
                            class="mx-1"
                            outlined
                            depressed
                            @click="redirectToLearnMore()">
                            Learn More
                        </v-btn>
                        <v-btn
                            class="mx-1"
                            depressed
                            color="accent2"
                            @click="openSubscribeToPremiumModal(graphicDetails.document_id)">
                            Subscribe To Premium
                        </v-btn>
                    </v-col>
                </v-row>
            </template>
        </confirm-dialog>
        <confirm-dialog
            :is-open="dialog"
            :width="800"
            @closed="() => this.dialog = false">
            <template v-slot:title>
                {{ graphicDetails.section_title }}
            </template>
            <template v-slot:default>
                <v-container>
                    <section class="view-graphic-modal__section">
                        <div
                            @contextmenu="(event) => handleRightClick(event, graphicDetails.document_sku)"
                            class="view-graphic-model__image pb-2"
                        >
                            <v-img
                                :src="graphicDetails.figure_url"
                                :alt="graphicDetails.alt_text.length > 0 ? graphicDetails.alt_text : `${graphicDetails.section_title} Graphic`"
                                max-height="300px"
                                style="max-height: 40vh; width: auto; object-fit: contain;"
                                contain
                                @error="loadPlaceholderImage"
                            />
                        </div>
                        <div class="view-graphic-modal__content v-card v-sheet theme--light v-card--flat mt-4 pa-3 rounded-lg section-border">
                            <div class="view-graphic-modal__content-body">
                                <div v-if="dialogLoading">
                                    <loading-linear>
                                    </loading-linear>
                                </div>
                                <div
                                    v-else
                                    v-html="graphicDetails.content">
                                </div>
                            </div>
                            <div v-if="isNotEmptyObject(graphicDetails.breadcrumbs)">
                                <item-breadcrumb
                                    class="mt-2"
                                    :meta="graphicDetails"
                                    :documentId="graphicDetails.document_id"
                                    :breadcrumbs="graphicDetails.breadcrumbs">
                                </item-breadcrumb>
                            </div>
                        </div>
                    </section>
                </v-container>
            </template>
            <template v-slot:buttons>
                <v-spacer>
                </v-spacer>
                <v-btn
                    outlined
                    color="primary"
                    @click="dialog = false">
                    Close
                </v-btn>
                <a
                    :href="redirectLink"
                    @click="logSearchClick(actionTypeMessage.jumpToSection)"
                    target="_blank">
                    <v-btn
                        class="ml-2"
                        :loading="dialogLoading"
                        color="primary">
                        Jump to Section
                        <v-icon
                            right>
                            mdi-open-in-new
                        </v-icon>
                    </v-btn>
                </a>
            </template>
        </confirm-dialog>
    </div>
</template>
<script>
import {GraphicsApi} from "../../../api/GraphicsApi";
import ConfirmDialog from "../../ConfirmDialog.vue";
import LoadingLinear from "../../loaders/LoadingLinear.vue";
import ItemBreadcrumb from "../content/result/item_breadcrumb.vue";
import GraphicSearchDetails from "./mixins/GraphicSearchDetails";
import {EventNames} from "../../../classes/EventNames";

export default {
        name: 'GraphicsDetails',
        data(){
            return {
                dialogLoading: false
            }
        },
        mixins: [
            GraphicSearchDetails
        ],
        components: {
            ConfirmDialog,
            LoadingLinear,
            ItemBreadcrumb
        },
        methods: {
            async getGraphicDetails(item) {
                this.graphicDetails = item;
                this.graphicDetails.breadcrumbs = {};
                this.searchTermId = item.searchTermId;
                if (this.getAccessLevel(item.document_sku, item.content_access_level_id) === 'premium') {
                    this.premiumRequiredDialog = true;
                } else {
                    this.dialogLoading = true;
                    this.dialog = true;

                    try {
                        const data = {
                            documentId: item.document_id,
                            contentId: item?.content_id
                        }
                        const response = await GraphicsApi.getFigureContent(data);
                        this.graphicDetails.content = this.removeAllImagesFromDom(response.content);
                        this.graphicDetails.breadcrumbs = response.breadcrumbs;
                    } finally {
                        this.dialogLoading = false;
                    }
                }
                this.logSearchClick(this.actionTypeMessage.resultOpen);
            },
            openSubscribeToPremiumModal(documentId){
                this.premiumRequiredDialog = false;
                EventBus.fire('show-premium-subscribe-dialog', {
                    getTitle: true,
                    documentId: documentId
                });
                this.logSearchClick(this.actionTypeMessage.subscribeToPremiumClick);
            },
            redirectToLearnMore(){
                this.logSearchClick(this.actionTypeMessage.learnMoreBtnClick).then(()=>{
                    this.goToRoute('premium_features');
                })
            }
        },
        created(){
            EventBus.listen(EventNames.GRAPHIC_DETAILS, (data)=>{
                this.getGraphicDetails(data);
            });
        }
    }
</script>
<style scoped>
    .view-graphic-modal__section {
        display: flex;
        flex-direction: column;
        height: 60vh;
    }
    .view-graphic-modal__content-body ::v-deep(span.section_number) {
        padding-right: 4px !important;
    }
    .section-border {
        border: 1px solid #0000001F !important;
    }
    .view-graphic-modal__content-body ::v-deep(h1.chapter span.label) {
        padding-right: 4px;
    }
    .view-graphic-model__image {
        flex: 0 0 40vh;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .view-graphic-modal__content {
        flex: 1;
    }
    .view-graphic-modal__content-body {
        position: relative;
        overflow: hidden;
        max-height: 13vh;
        line-height: 1.5em;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>
